export const LOAD_POSITIONS_SUCCEEDED = 'LOAD_POSITIONS_SUCCEEDED';
export const LOAD_POSITIONS_FAILED = 'LOAD_POSITIONS_FAILED';

export const LOAD_PARTNER_DETAILS_STARTED = 'LOAD_PARTNER_DETAILS_STARTED';
export const LOAD_PARTNER_DETAILS_SUCCEEDED = 'LOAD_PARTNER_DETAILS_SUCCEEDED';
export const LOAD_PARTNER_DETAILS_FAILED = 'LOAD_PARTNER_DETAILS_FAILED';

export const UPDATE_CONTACT_PERSONS_STARTED = 'UPDATE_CONTACT_PERSONS_STARTED';
export const UPDATE_CONTACT_PERSONS_SUCCEEDED = 'UPDATE_CONTACT_PERSONS_SUCCEEDED';
export const UPDATE_CONTACT_PERSONS_FAILED = 'UPDATE_CONTACT_PERSONS_FAILED';

export const LOAD_CONTACT_PERSONS_STARTED = 'LOAD_CONTACT_PERSONS_STARTED';
export const LOAD_CONTACT_PERSONS_SUCCEEDED = 'LOAD_CONTACT_PERSONS_SUCCEEDED';
export const LOAD_CONTACT_PERSONS_FAILED = 'LOAD_CONTACT_PERSONS_FAILED';

export const LOAD_CONTACT_PERSONS_SUMMARY_SUCCEEDED = 'LOAD_CONTACT_PERSONS_SUMMARY_SUCCEEDED';
